<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-text-field label="Address" :value="strAddress" v-on="on"></v-text-field>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Address Editor</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" >
                            <v-text-field
                                    v-model="zipCode"
                                    label="zipCode"
                                    required
                                    clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" >
                            <v-text-field clearable v-model="city" label="City"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" >
                            <v-select
                                    :items="available_countries"
                                    :hint="`${country.country}`"
                                    item-text="abbr"
                                    item-value="abbr"
                                    label="Country"
                                    v-model="country"
                                    persistent-hint
                                    return-object
                                    single-line
                                    clearable
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="8" >
                            <v-text-field clearable label="Complement" v-model="complement" required></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                <v-btn color="blue darken-1" text @click="saveAddress">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'AddressInput',
        data: () => ({
            dialog: false,
            zipCode: null,
            country: {},
            complement: "",
            city:"",
            available_countries: [

                { country: 'France', abbr: 'FR' },
                { country: 'United Kingdom', abbr: 'UK' },
                { country: 'Germany', abbr: 'DE' },
                { country: 'United States of America', abbr: 'USA' },
                { country: 'Nearland', abbr: 'NL' },
                { country: 'Swiss', abbr: 'SW' },
                { country: 'China', abbr: 'CH' },
                { country: 'Belgium', abbr: 'BE' },
            ]
        }),
        props: {
            address: JSON,
        },
        methods: {
            saveAddress () {
                this.dialog = false;
                this.$emit('change', {
                    country: this.country.abbr,
                    zipCode: this.zipCode,
                    city: this.city,
                    address: this.complement
                });

            }
        },
        computed: {
            strAddress: function(){
                if (this.complement) {
                    return `${this.complement} ; ${this.zipCode} - ${this.city} (${this.country.country})`
                }else{
                    return null
                }
            }
        }
    }
</script>
